import SeoLandingPage from "@/components/SeoLandingPage";

const ValgrindMemoryLeaks = () => <SeoLandingPage pageKey="valgrindMemoryLeaks" />;

export default ValgrindMemoryLeaks;
